import { createEmptyAction, createMapAction } from "chalet-shared";

import { Config } from "../reducers/config";

export const actionCreators = {
    loadConfigRequested: createEmptyAction("LOAD_CONFIG_REQUESTED"),
    loadConfigStarted: createEmptyAction("LOAD_CONFIG_STARTED"),
    loadConfigSuccess: createMapAction("LOAD_CONFIG_SUCCESS", (x: Config) => x),
    loadConfigFailed: createEmptyAction("LOAD_CONFIG_FAILED"),
};
